// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drag-zone[data-v-70a68a0b]{cursor:pointer;border:2px dashed #ccc!important;-webkit-transition:all .3s ease;transition:all .3s ease}.drag-over[data-v-70a68a0b],.drag-zone[data-v-70a68a0b]:hover{background-color:#f0f8ff!important;border-color:#1976d2!important}", ""]);
// Exports
module.exports = exports;
